import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React from 'react';
import { Button } from 'module-tsl-ui-elements';
import { getLocationDetails, loadMapsApi, fetchLocation } from './transforms.js';
export var LocationPicker = function LocationPicker(props) {
  var mapsApiKey = props.mapsApiKey,
      _props$defaultText = props.defaultText,
      defaultText = _props$defaultText === void 0 ? 'Use current location' : _props$defaultText,
      handleLocationValues = props.handleLocationValues,
      dispatch = props.dispatch;

  var getReadableLocation = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(coordinates) {
      var response, locationDetails, items;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchLocation(coordinates);

            case 3:
              response = _context.sent;
              locationDetails = getLocationDetails(response);

              if (locationDetails && locationDetails.label) {
                items = {
                  location: null,
                  value: locationDetails.label,
                  coordinates: "".concat(coordinates.lat, ",").concat(coordinates.lng)
                };
                handleLocationValues({}, items);
                dispatch({
                  type: 'active',
                  active: false
                });
              } else {
                dispatch({
                  type: 'error',
                  error: 'No location found'
                });
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              dispatch({
                type: 'error',
                error: 'Error getting your location'
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function getReadableLocation(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var getPosition = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(position) {
      var _position$coords, latitude, longitude;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(position && position.coords)) {
                _context2.next = 4;
                break;
              }

              _position$coords = position.coords, latitude = _position$coords.latitude, longitude = _position$coords.longitude;
              _context2.next = 4;
              return getReadableLocation({
                lat: Number(latitude),
                lng: Number(longitude)
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getPosition(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var errorHandling = function errorHandling() {
    dispatch({
      type: 'error',
      error: 'No connection'
    });
    dispatch({
      type: 'loading',
      loading: false
    });
  };

  var getCurrentPosition = function getCurrentPosition() {
    window.navigator.geolocation.getCurrentPosition(getPosition, errorHandling);
    dispatch({
      type: 'suggestions',
      suggestions: []
    });
  };

  var getCurrentLocation = function getCurrentLocation() {
    dispatch({
      type: 'loading',
      loading: true
    });

    if (!window.google || !window.google.maps) {
      loadMapsApi(mapsApiKey);
    } else {
      getCurrentPosition();
    } // This will be triggered by the google map callback function when script is loaded


    window.mapsApiReady = function () {
      getCurrentPosition();
    };
  };

  var classNames = ['tds-location-picker', props.customClass].join(' ').trim();
  return 'geolocation' in navigator ? /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: classNames,
    icon: "tds-current-location",
    onClick: getCurrentLocation,
    size: "lg",
    theme: "tertiary-monotone",
    id: "location-picker"
  }, defaultText) : /*#__PURE__*/React.createElement("noscript", null);
};